import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getDateNaissanceInconnueFRFromYYYYMMDD } from 'components/Commun/Form/Date/dateTranformation';
import { Button, CardV2, CardBody, CardContent, CardFooter, Row, Col } from '@si-armes/dsfr-react';
import styles from './InformationsPersonnelles.module.scss';
import RoutesMonCompte from '../../../pages/espace-detenteurs/mon-compte/routes';
import { getPath } from '../../../utils/router';

const InformationsPersonnelles = ({ personnePhysique, titre, afficherBoutonAction }) => {
    const {
        sexe,
        nomUsage,
        nom,
        prenomUsuel,
        prenomUn,
        prenomDeux,
        prenomTrois,
        prenomQuatre,
        dateNaissance,
        lieuNaissance,
        cpNaissance,
        paysNaissance,
        nationalite,
    } = personnePhysique;

    const history = useHistory();
    const getNomUsage = () => {
        if (!personnePhysique) {
            return '';
        }
        if (nomUsage) {
            return nomUsage;
        }
        return nom;
    };

    const getPrenomUsuel = () => {
        if (!personnePhysique) {
            return '';
        }
        if (prenomUsuel) {
            return prenomUsuel;
        }
        return prenomUn;
    };

    const modificationInformation = () => {
        history.push(getPath(RoutesMonCompte.subroutes.ecranGestion));
    };

    return (
        <>
            <CardV2 taille="lg" noEnlargeLink>
                <CardBody>
                    <CardContent>
                        <div className={styles.informationsPersonnelles}>
                            <div className={styles.informationsPersonnelles__informations}>
                                {titre && (
                                    <>
                                        <Row>
                                            <Col col={12}>
                                                <div
                                                    className={
                                                        styles.informationsPersonnelles__informations__titre
                                                    }
                                                >
                                                    <span
                                                        className="fr-icon-account-circle-fill icon-color"
                                                        aria-hidden="true"
                                                    />{' '}
                                                    {titre}
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                <div
                                    className={styles.informationsPersonnelles__informations__line}
                                >
                                    {getNomUsage()} {getPrenomUsuel()} {prenomDeux} {prenomTrois}{' '}
                                    {prenomQuatre}
                                </div>
                                <div
                                    className={styles.informationsPersonnelles__informations__line}
                                >
                                    Sexe : {sexe === 1 ? 'Masculin' : 'Feminin'}
                                </div>
                                <div
                                    className={styles.informationsPersonnelles__informations__line}
                                >
                                    Né(e) le {getDateNaissanceInconnueFRFromYYYYMMDD(dateNaissance)}{' '}
                                    à {lieuNaissance} {cpNaissance && `(${cpNaissance})`},{' '}
                                    {paysNaissance.libelle}
                                </div>
                                <div
                                    className={styles.informationsPersonnelles__informations__line}
                                >
                                    Nationalité : {nationalite}
                                </div>
                            </div>
                        </div>
                    </CardContent>
                    <CardFooter>
                        {afficherBoutonAction && (
                            <div className={styles.informationsPersonnelles__boutons}>
                                <Button
                                    icon="fr-fi-edit-line"
                                    iconPosition="left"
                                    onClick={modificationInformation}
                                    variant="secondary"
                                >
                                    Modifier les informations
                                </Button>
                            </div>
                        )}
                    </CardFooter>
                </CardBody>
            </CardV2>
        </>
    );
};

InformationsPersonnelles.propTypes = {
    personnePhysique: PropTypes.shape({
        nom: PropTypes.string.isRequired,
        nomUsage: PropTypes.string.isRequired,
        prenomUsuel: PropTypes.string.isRequired,
        prenomUn: PropTypes.string.isRequired,
        prenomDeux: PropTypes.string.isRequired,
        prenomTrois: PropTypes.string.isRequired,
        prenomQuatre: PropTypes.string.isRequired,
        sexe: PropTypes.number,
        dateNaissance: PropTypes.string,
        lieuNaissance: PropTypes.string,
        cpNaissance: PropTypes.string,
        paysNaissance: PropTypes.string.isRequired,
        nationalite: PropTypes.object.isRequired,
    }).isRequired,
    titre: PropTypes.string,
    afficherBoutonAction: PropTypes.bool,
};

InformationsPersonnelles.defaultProps = {};

export default connect()(InformationsPersonnelles);
